<template>
  <div id="app">
    <router-view></router-view>
    <LoginModal 
      :visible="showLoginModal" 
      :type="loginModalType" 
      @close="closeLoginModal"
      :z-index="9999"
    />
  </div>
</template>

<script>
import LoginModal from './components/LoginModal.vue'

export default {
  name: 'App',
  components: {
    LoginModal
  },
  data() {
    return {
      showLoginModal: false,
      loginModalType: 'login'
    }
  },
  mounted() {
    // 监听全局事件，显示登录弹窗
    this.$root.$on('showLoginModal', (type) => {
      this.showGlobalLoginModal(type)
    })
    
    // 监听页面级别的登录弹窗事件
    this.$root.$on('showPageLoginModal', (type) => {
      this.showPageLoginModal(type)
    })
  },
  methods: {
    showGlobalLoginModal(type) {
      // 全局登录弹窗，优先级最高
      console.log('App.vue 显示全局登录弹窗:', type)
      this.loginModalType = type || 'login'
      this.showLoginModal = true
    },
    
    showPageLoginModal(type) {
      // 页面级别登录弹窗，如果全局弹窗已显示则不显示
      if (!this.showLoginModal) {
        this.loginModalType = type || 'login'
        this.showLoginModal = true
      }
    },
    
    closeLoginModal() {
      console.log('App.vue 关闭登录弹窗')
      this.showLoginModal = false
    }
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('showLoginModal')
    this.$root.$off('showPageLoginModal')
  }
}
</script>

<style>
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
button,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
input,
select,
textarea,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  text-align: left;
  list-style-type: none;
  outline: none;
  cursor: pointer;
  text-decoration: none;
}

input {
  outline: none;
}
</style>
